import { useBooleanFlagValue } from '@openfeature/react-sdk';
import SpaceBetween from '@risk-smart/themed-cloudscape-components/space-between';
import type { FC } from 'react';
import { useI18NSummaryHelpContent } from 'src/components/help-panel/useSummaryHelpContent';
import type { ObjectWithContributors } from 'src/rbac/Permission';
import { useHasPermissionQuery } from 'src/rbac/useHasPermission';

import { useIsModuleEnabled } from '@/hooks/useIsModuleEnabled';

import ScoreHistorySection from '../score-history/ScoreHistorySection';
import ComplianceRatingRegister from './ComplianceRatingRegister';
import InternalAuditRatingRegister from './InternalAuditRatingRegister';
import RiskRatingRegister from './RiskRatingRegister';

interface Props {
  risk: ObjectWithContributors & { Tier?: number };
}

const Tab: FC<Props> = ({ risk }) => {
  useI18NSummaryHelpContent('assessments.tabHelp');
  const oversightEnabled = useIsModuleEnabled(
    'assessment.subModules.oversight_register_and_findings'
  );
  const internalAuditEnabled = useIsModuleEnabled('internal_audit_entity');
  const scoreHistoryEnabled = useBooleanFlagValue('risk_score_history', false);
  const {
    hasPermission: canViewCompliance,
    loading: canViewComplianceLoading,
  } = useHasPermissionQuery('read:oversight_assessment', risk);
  const {
    hasPermission: canViewInternalAudit,
    loading: canViewInternalAuditLoading,
  } = useHasPermissionQuery('read:internal_audit_report', risk);

  return (
    <SpaceBetween size={'m'}>
      <RiskRatingRegister risk={risk} />
      {oversightEnabled && canViewCompliance && !canViewComplianceLoading && (
        <ComplianceRatingRegister risk={risk} />
      )}
      {internalAuditEnabled &&
        canViewInternalAudit &&
        !canViewInternalAuditLoading && (
          <InternalAuditRatingRegister risk={risk} />
        )}
      {scoreHistoryEnabled && <ScoreHistorySection riskId={risk.Id} />}
    </SpaceBetween>
  );
};

export default Tab;
